<div
  class="flex items-center justify-start gap-2 w-full min-h-[33px] rounded-lg px-4 py-2"
  [ngClass]="selected ? 'bg-feedback-success-light' : 'bg-neutral-100'"
  data-testid="chip"
>
  <ui-icon name="check" size="16" mobile-size="16" [fill]="colorText"></ui-icon>
  <ui-paragraph
    type="p14"
    mobile-type="p14"
    font-weight="regular"
    [textColor]="colorText"
    [content]="content"
  ></ui-paragraph>
</div>
